import React from 'react';
import userPlaceholder from "../assets/images/user_placeholder.png";

// const SPEAKER_PLACEHOLDER = 'https://placehold.co/280x320/e5e7eb/6b7280?text=Speaker';

function SpeakerCard({ name, specialty, imageSrc }) {
  return (
    <article className="speaker-card">
      <div className="speaker-card-image-wrap">
        <img src={imageSrc || userPlaceholder} alt={name} className="speaker-card-image" />
      </div>
      <h3 className="speaker-card-name">{name}</h3>
      <p className="speaker-card-specialty">{specialty}</p>
    </article>
  );
}

export default SpeakerCard;
